import React from "react";
import Parameters from "./Parameters/Parameters";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import Close from "@material-ui/icons/Close";

function AiFields({
  data,
  setOpen,
  action,
  variables,
  setOpenVariable,
  automId
}) {

  const { t } = useTranslation();
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog id="autom-addNew-modal" data-test="autom-add-new" open={true} PaperProps={{
      style: {
        minWidth: 600
      }
    }}>
      <DialogTitle
        id="alert-dialog-title"
      >
        <div id="about-title">
          {t('CONTENT.CONFIGURATION-FORM.AI.CONFIGURE')}
          <Button data-test="cancelautom-button" onClick={handleClose}>
            <Close />
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className="form-element">
              <span id="about-title">
                {t('CONTENT.CONFIGURATION-FORM.AI.PARAMETERS')}
              </span>
              <Parameters
                action={action}
                variables={variables}
                setOpenVariable={setOpenVariable}
                automId={automId}
                data={data}
              />
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: "flex-end",
          padding: "8px 24px 16px 24px",
        }}
      >
        <Button onClick={handleClose} variant="outlined"
          style={{
            backgroundColor: "#46474E",
            borderRadius: "2px",
            color: "#fff",
            border: "none",
            fontWeight: 700
          }}
        >Save</Button>
      </DialogActions>
    </Dialog>
  );
}

export default AiFields;



